import type { LocationSearchParams } from '@/features/accommodation/hooks/useLocatiomSearchParams'
import type { LandingPage } from './types'

const OFFER_LIMIT = 24

/** Turn a landing page's intrinsic filter into the search params the query hook expects. */
export function toSearchParams(page: LandingPage): LocationSearchParams {
  return {
    fromDate: undefined,
    toDate: undefined,
    region: page.filter.region ?? 'all',
    labelId: page.filter.labelId,
    beds: 1,
    cribs: 0,
    adult: false,
    pets: page.filter.pets ?? false,
    facility: page.filter.facility,
    category: page.filter.category,
    skip: 0,
    take: OFFER_LIMIT,
    order: 'start',
    direction: 'asc',
  }
}
